import { createReducer } from 'reduxsauce'
import { Types } from '../actions/empresasActions'

const INITIAL_STATE = { error: false, loading: false, empresas: null, statusUpload: null }

const begin = (state = INITIAL_STATE, action) => {
    return { ...state, error: false, loading: true, empresas: null }
}
const success = (state = INITIAL_STATE, action) => {
    return { ...state, error: false, loading: false, empresas: action.empresas }
}
const failure = (state = INITIAL_STATE, action) => {
    return { ...state, error: action.error, loading: false, empresas: null }
}

const successPfx = (state = INITIAL_STATE, action) => {
    return { ...state, statusUpload: action.status }
}
const failurePfx = (state = INITIAL_STATE, action) => {
    return { ...state, statusUpload: action.status }
}

const HANDLERS = {
    [Types.FETCH_EMPRESAS_BEGIN]: begin,
    [Types.FETCH_EMPRESAS_SUCCESS]: success,
    [Types.FETCH_EMPRESAS_FAILURE]: failure,
    [Types.UPLOAD_PFX_SUCCESS]: successPfx,
    [Types.UPLOAD_PFX_FAILURE]: failurePfx
}

export default createReducer(INITIAL_STATE, HANDLERS)